import React from 'react';
import { useTranslation } from 'react-i18next';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import ViewListIcon from '@mui/icons-material/ViewList';
import EventRepeatIcon from '@mui/icons-material/EventRepeat';

export type ViewMode = 'date' | 'weekday';

interface ViewModeToggleProps {
  value: ViewMode;
  onChange: (mode: ViewMode) => void;
}

const ViewModeToggle = ({ value, onChange }: ViewModeToggleProps) => {
  const { t } = useTranslation();

  const handleChange = (_event: React.MouseEvent<HTMLElement>, nextMode: ViewMode | null) => {
    if (nextMode !== null) onChange(nextMode);
  };

  return (
    <ToggleButtonGroup
      value={value}
      exclusive
      onChange={handleChange}
      size="small"
      aria-label={t('common.viewToggleLabel')}
      sx={{
        bgcolor: 'action.hover',
        borderRadius: 999,
        padding: 0.5,
        '& .MuiToggleButtonGroup-grouped': {
          border: 0,
          borderRadius: 999,
          textTransform: 'none',
          px: 2,
          '&.Mui-selected': {
            bgcolor: 'background.paper',
            boxShadow: 1,
          },
        },
      }}
    >
      <ToggleButton value="date" aria-label={t('common.viewChronological')}>
        <ViewListIcon fontSize="small" sx={{ marginRight: 1 }} />
        {t('common.viewChronological')}
      </ToggleButton>
      <ToggleButton value="weekday" aria-label={t('common.viewByDay')}>
        <EventRepeatIcon fontSize="small" sx={{ marginRight: 1 }} />
        {t('common.viewByDay')}
      </ToggleButton>
    </ToggleButtonGroup>
  );
};

export default ViewModeToggle;
